/*eslint-disable*/
import React, { Component } from "react";
// reactstrap components
import { CardHeader, Container, Row } from "reactstrap";
import { Grid, GridItem } from "@chakra-ui/react";
// Redux
import { connect } from "react-redux";
import {
  getSections,
  getEnums,
  updateSurvey,
  saveSurvey,
} from "../../utils/store/actions/survey.action";
import { show } from "redux-modal";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
// material ui
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
// import Grid from "@material-ui/core/Grid";
import Toolbar from "@material-ui/core/Toolbar";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Card from "@material-ui/core/Card";
import SaveIcon from "@material-ui/icons/Save";
// core components
import Header from "../../components/Headers/Header";
import ModalSurvey from "../../components/Modal/Modal.survey";
import { quesionaireHostUri } from "../../utils/uri";
import { AppBar, Checkbox, FormControlLabel } from "@material-ui/core";
import ConfigQuestionnaire from "../../components/ConfigQuestionnaire/ConfigQuestionnaire";

const styles = (theme: Theme) =>
  createStyles({
    paper: {
      backgroundColor: "#F5F6FF",
      margin: "auto",
      overflow: "hidden",
    },
    searchBar: {
      backgroundColor: "#F5F6FF",
      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
    searchInput: {
      backgroundColor: "#F5F6FF",
      fontSize: theme.typography.fontSize,
    },
    block: {
      display: "block",
    },
    addUser: {
      marginRight: theme.spacing(1),
    },
    contentWrapper: {
      margin: "40px 16px",
    },
  });
class SurveyDetails extends Component<any, any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      open: false,
      checked: [],
      expanded: [],
      modalOpen: false,
      savedModal: false,
      loading: true,
      showConfiguredOnly: true,
    };
  }

  async componentDidMount() {
    await this.props.getSections(this.props.party);
    await this.props.getEnums();

    this.setState({ checked: this.props.Surveys.sections, loading: false });
  }

  checkedInit() {
    const findChecked = (el: any) => {
      el.forEach((el: any) => {
        if (el.questions !== []) {
          el.questions.forEach((q: any, i: any) => {
            q.visible ? this.state.checked.push(q.id) : null;
          });
        }
        if (el.subSection !== []) {
          findChecked(el.subSection);
        }
      });
    };
    findChecked(this.props.Surveys.sections);
  }

  handleOpenModal = () => {
    this.setState({ modalOpen: !this.state.modalOpen });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  toggleShowConfiguredOnly = () => {
    const showConfiguredOnly = !this.state.showConfiguredOnly;
    this.setState({ ...this.state, showConfiguredOnly });
  };

  render() {
    const { Surveys, classes } = this.props;

    if (Surveys.sort_sections && Surveys.sections) {
      if (this.state.loading) {
        return (
          <Paper className={classes.paper}>
            Loading data...
            <Loader type="ThreeDots" color="#4B0084" height={50} width={50} />
          </Paper>
        );
      } else {
        this.checkedInit();
        return (
          <Grid flex column gap="20px">
            <ModalSurvey saveSurvey={this.props.saveSurvey} Surveys={Surveys} />
            <Paper className={classes.paper}>
              <AppBar
                className={classes.searchBar}
                position="static"
                color="default"
                elevation={0}
              >
                <Toolbar>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item>
                      <ButtonGroup
                        variant="text"
                        color="primary"
                        aria-label="text primary button group"
                      >
                        <Tooltip title="Save config" placement="top">
                          <IconButton
                            aria-label="save"
                            style={{ backgroundColor: "#F5F6FF" }}
                            onClick={() =>
                              this.props.show("survey", {
                                name: "survey",
                                host: quesionaireHostUri,
                                history,
                              })
                            }
                          >
                            <SaveIcon />
                          </IconButton>
                        </Tooltip>
                      </ButtonGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={this.toggleShowConfiguredOnly}
                            id={`show-configured-questions-only`}
                            checked={this.state.showConfiguredOnly}
                            inputProps={{
                              "aria-label": "primary checkbox",
                            }}
                          />
                        }
                        label='Show configured question only'
                      />
                    </Grid>
                  </Grid>
                </Toolbar>
              </AppBar>
              <Grid
                templateRows="repeat(13, 1fr)"
                templateColumns="repeat(8, 1fr)"
                gap={6}
              >
                <GridItem
                  rowSpan={13}
                  colSpan={8}
                  bg="brand.white"
                  borderRadius="2xl"
                >
                  {Surveys && <ConfigQuestionnaire configuredOnly={this.state.showConfiguredOnly} party={this.props.party} />}
                </GridItem>
              </Grid>
            </Paper>
          </Grid>
        );
      }
    } else {
      return (
        <>
          <Header />
          {/* Page content */}
          <Container className="mt--7" fluid>
            {/* Table */}
            <Row>
              <div className="col">
                <Card className="shadow">
                  <CardHeader className="fa5 border-0">
                    <h3 className="mb-0">Questions disponibles</h3>
                  </CardHeader>
                </Card>
              </div>
            </Row>
          </Container>
        </>
      );
    }
  }
}

const mapStateToProps = (state: { Surveys: SurveyState }) => ({
  Surveys: state.Surveys,
});

const mapDispatchToProps = {
  getSections,
  getEnums,
  updateSurvey,
  saveSurvey,
  show,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SurveyDetails));
